import React, { useEffect, useRef, useState } from "react";
import {
  useTourGuidConfigActionsContext,
  useTourGuidConfigContext,
  useTourGuidStartActionsContext,
  useTourGuidStartContext,
  useTourGuidStoryTrackerContext,
} from "../../Context/TourGuidContext";
import TourGuide from "./tourGuide";
import TourStepsProvider from "./TourStepsProvider";
import UserTourGuideConstants from "../../Constants/UserTourConstants";
import userTourGuid from "../../Stores/UserTourGuidStores";
import { toast } from "react-toastify";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import UserTourGuidAction from "../../Actions/UserTourGuidAction";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useEqDetailsTabContext } from "../../Context/GlobalContext";

export default function TourGuideWrapper() {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const startTour = useTourGuidStartContext();
  const guideTourstate = useTourGuidConfigContext();
  const setGuideTourState = useTourGuidConfigActionsContext();
  const UpdateTourStatus = useTourGuidStartActionsContext();
  const tourStoryTracker = useTourGuidStoryTrackerContext();
  const tabSelected = useEqDetailsTabContext();
  const currentTourID = useRef("");

  useEffect(() => {
    if (startTour.tourStatus) {
      const tourGuideStoryTitle = JSON.parse(
        sessionStorage.getItem("onBoardStoryGuid")
      );
      const activeTour = tourGuideStoryTitle.find(
        (tour) => tour.title === startTour.tourTitle
      );
      currentTourID.current = {
        id: activeTour.id,
        status: activeTour.isTourActive,
      };
      const generatedSteps = TourStepsProvider({
        currentStepTitle: activeTour.title,
        id: activeTour.id,
        handleCheckBoxClick: handleCheckBoxClick,
        localization,
        setGuideTourState,
        isTourDisabled: activeTour.isTourActive,
        lastIndexKey: startTour.lastIndexKey,
        firstIndexKey: startTour.firstIndexKey,
        tabSelected: tabSelected?.tabDetails,
      });
      setGuideTourState({
        run: true,
        stepIndex: startTour.anyStep,
        steps: generatedSteps,
        tourActive: true,
        tourTitle: activeTour.title,
        tourId: activeTour.id,
      });
    }
  }, [startTour]);

  useEffect(() => {
    function disableTourSuccess() {
      toast.success(localization.tourDisableSuccessMessage);
      handleClose();
      const tourGuideStoryTitle = JSON.parse(
        sessionStorage.getItem("onBoardStoryGuid")
      );
      const updatedTourGuideStoryTitle = tourGuideStoryTitle.map((item) => {
        if (item.id === currentTourID.current["id"]) {
          return {
            ...item,
            isTourActive: false, // Corrected syntax here
          };
        }
        return item;
      });
      sessionStorage.setItem(
        "onBoardStoryGuid",
        JSON.stringify(updatedTourGuideStoryTitle)
      );
      setGlobalSpinner(false);
    }

    function disableTourFailure() {
      var res = userTourGuid.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    userTourGuid.addChangeListener(
      UserTourGuideConstants.DISABLE_TOUR_SUCESS,
      disableTourSuccess
    );

    userTourGuid.addChangeListener(
      UserTourGuideConstants.DISABLE_TOUR_FAILURE,
      disableTourFailure
    );
    return () => {
      userTourGuid.removeChangeListener(
        UserTourGuideConstants.DISABLE_TOUR_SUCESS,
        disableTourSuccess
      );

      userTourGuid.removeChangeListener(
        UserTourGuideConstants.DISABLE_TOUR_FAILURE,
        disableTourFailure
      );
    };
  }, []);

  function handleCheckBoxClick(_data) {
    setGlobalSpinner(true);
    const _apiPayload = {
      GuidedTourId: _data,
      IsTourActive: false,
    };
    UserTourGuidAction.disablePaticularTour(_apiPayload);
  }

  function handleClose() {
    setGuideTourState({
      run: false,
      stepIndex: 0,
      steps: [],
      tourActive: false,
      tourTitle: "",
    });
    UpdateTourStatus({
      tourTitle: "",
      tourStatus: false,
      anyStep: 0,
    });
  }
  return (
    guideTourstate &&
    guideTourstate.tourActive && <TourGuide handleClose={handleClose} />
  );
}
